
function getPagerStartEndObject(currentPageNumber, pageCount, spread) {
    var obj = {
        start: currentPageNumber - spread,
        end: currentPageNumber + spread,
    };

    spread = spread * 2;

    if (obj.start < 1) {
        obj.start = 1;
        obj.end = obj.start + spread;
    }

    if (obj.end > pageCount) {
        obj.start = pageCount - spread;
        obj.end = pageCount;
    }

    // if the spread position is too big or too small we fix it here.
    if (obj.start < 1) obj.start = 1;
    if (obj.end > pageCount) obj.end = pageCount;

    return obj;
}

/**
 * Create pagination button
 * @param {string} direction Either 'previous' or 'next'
 * @param {number} currentPageNumber
 * @param {number} pageCount
 * @return {jQuery} Pagination button element
 * @private
 */
function getPagerButton(direction, currentPageNumber, pageCount) {
    var targetIndex =
        direction === "Prev" ? currentPageNumber - 1 : currentPageNumber + 1;
    var showButton =
        direction === "Prev"
            ? currentPageNumber > 1
            : currentPageNumber < pageCount;
    var linkText =
        direction === "Prev"
            ? '<svg class="govuk-pagination__icon govuk-pagination__icon--prev" xmlns="http://www.w3.org/2000/svg" height="13" width="15" aria-hidden="true" focusable="false" viewBox="0 0 15 13">\n' +
            '  <path d="m6.5938-0.0078125-6.7266 6.7266 6.7441 6.4062 1.377-1.449-4.1856-3.9768h12.896v-2h-12.984l4.2931-4.293-1.414-1.414z"></path>\n' +
            '</svg>' +
            '<span class="govuk-pagination__link-title">Previous</span>'
            : '<span class="govuk-pagination__link-title">Next</span>' +
            '<svg class="govuk-pagination__icon govuk-pagination__icon--next" xmlns="http://www.w3.org/2000/svg" height="13" width="15" aria-hidden="true" focusable="false" viewBox="0 0 15 13">\n' +
            '  <path d="m8.107-0.0078125-1.4136 1.414 4.2926 4.293h-12.986v2h12.896l-4.1855 3.9766 1.377 1.4492 6.7441-6.4062-6.7246-6.7266z"></path>\n' +
            '</svg>';
    var $link = $(`<button class="govuk-link govuk-pagination__link govuk-pagination__button">${linkText}</button>`);
    $link.addClass(`govuk-pagination__${direction === "Prev" ? "prev" : "next"}`);
    $link.on("click", function (e) {
        $(e.target).closest(".data-grid").jsGrid("openPage", targetIndex);
    });

    return showButton ? $link.addClass("pager-" + direction.toLowerCase()) : "";
}

function getPager(currentPageNumber, pageCount) {
    let $pageItems = $('<ul class="pager-items"/>');

    let callback = function (e) {
        $(e.target)
            .closest(".data-grid")
            .jsGrid("openPage", $(e.target).data("page-target"));
    };

    let spread = 5;

    let startEndObject = getPagerStartEndObject(
        currentPageNumber,
        pageCount,
        spread,
    );

    for (var i = startEndObject.start; i <= startEndObject.end; i++) {
        var $items = $('<li class="govuk-pagination__item"/>').appendTo($pageItems);

        if (i !== currentPageNumber) {
            $('<button class="govuk-link govuk-pagination__link govuk-pagination__button"></button>')
                .text(i)
                .attr("data-page-target", i)
                .on("click", callback)
                .appendTo($items);
        } else {
            $items.addClass('govuk-pagination__item--current');
            $items.text(i);
        }
    }

    return $pageItems;
}

module.exports = {
    getPagerButton,
    getPager
}
